/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactSummary } from './ContactSummary.js';
import {
    ContactSummaryFromJSON,
    ContactSummaryFromJSONTyped,
    ContactSummaryToJSON,
} from './ContactSummary.js';
import type { CustomerPreview } from './CustomerPreview.js';
import {
    CustomerPreviewFromJSON,
    CustomerPreviewFromJSONTyped,
    CustomerPreviewToJSON,
} from './CustomerPreview.js';
import type { TaskSuggestionStatusType } from './TaskSuggestionStatusType.js';
import {
    TaskSuggestionStatusTypeFromJSON,
    TaskSuggestionStatusTypeFromJSONTyped,
    TaskSuggestionStatusTypeToJSON,
} from './TaskSuggestionStatusType.js';
import type { User } from './User.js';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User.js';

/**
 * 
 * @export
 * @interface TaskSuggestion
 */
export interface TaskSuggestion {
    /**
     * 
     * @type {number}
     * @memberof TaskSuggestion
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TaskSuggestion
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskSuggestion
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof TaskSuggestion
     */
    dueDate?: Date;
    /**
     * 
     * @type {TaskSuggestionStatusType}
     * @memberof TaskSuggestion
     */
    status?: TaskSuggestionStatusType;
    /**
     * 
     * @type {number}
     * @memberof TaskSuggestion
     */
    priority?: number;
    /**
     * 
     * @type {Date}
     * @memberof TaskSuggestion
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TaskSuggestion
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof TaskSuggestion
     */
    source?: string;
    /**
     * 
     * @type {User}
     * @memberof TaskSuggestion
     */
    assignedUser?: User;
    /**
     * 
     * @type {User}
     * @memberof TaskSuggestion
     */
    user?: User;
    /**
     * 
     * @type {CustomerPreview}
     * @memberof TaskSuggestion
     */
    customer?: CustomerPreview;
    /**
     * 
     * @type {ContactSummary}
     * @memberof TaskSuggestion
     */
    contact?: ContactSummary;
}

/**
 * Check if a given object implements the TaskSuggestion interface.
 */
export function instanceOfTaskSuggestion(value: object): boolean {
    return true;
}

export function TaskSuggestionFromJSON(json: any): TaskSuggestion {
    return TaskSuggestionFromJSONTyped(json, false);
}

export function TaskSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'status': json['status'] == null ? undefined : TaskSuggestionStatusTypeFromJSON(json['status']),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'source': json['source'] == null ? undefined : json['source'],
        'assignedUser': json['assignedUser'] == null ? undefined : UserFromJSON(json['assignedUser']),
        'user': json['user'] == null ? undefined : UserFromJSON(json['user']),
        'customer': json['customer'] == null ? undefined : CustomerPreviewFromJSON(json['customer']),
        'contact': json['contact'] == null ? undefined : ContactSummaryFromJSON(json['contact']),
    };
}

export function TaskSuggestionToJSON(value?: TaskSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'content': value['content'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString()),
        'status': TaskSuggestionStatusTypeToJSON(value['status']),
        'priority': value['priority'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'source': value['source'],
        'assignedUser': UserToJSON(value['assignedUser']),
        'user': UserToJSON(value['user']),
        'customer': CustomerPreviewToJSON(value['customer']),
        'contact': ContactSummaryToJSON(value['contact']),
    };
}

